import React, { useState } from "react";
import backBtn from "../../assets/images/backBtn.svg";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import { useLocation, useNavigate } from "react-router-dom";
import breadcrumb from "../../assets/images/breadcrumb.svg";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import { setItem } from "../../common/localStorage";
// import ShowMoreText from "react-show-more-text";

const QuizList = () => {
  const [expandedIndexes, setExpandedIndexes] = useState([]);

  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation();

  const toggleShowMore = (index) => {
    setExpandedIndexes(
      (prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) // Remove index if already expanded
          : [...prev, index] // Add index if not expanded
    );
  };

  return (
    <>
      <div className="py-50 mobileMargin">
        <div className="container">
          <div className="doctorGrid">
            {state?.item?.quizData?.map((itemQuizData, indexQuizData) => {
              return itemQuizData?.quizSet?.map((itemQuizSet, indexQuizSet) => {
                const progressPercentage = itemQuizSet?.setQuestionsCount
                  ? (itemQuizSet?.setAttemptedQuestionsCount /
                      itemQuizSet?.setQuestionsCount) *
                    100
                  : 0;
                const isExpanded = expandedIndexes.includes(
                  `${indexQuizData}-${indexQuizSet}`
                );
                return (
                  <>
                    <div
                      className="doctorCard"
                      key={`quiz-set-${indexQuizData}-${indexQuizSet}`}
                    >
                      <div className="progressBar mb-8">
                        <div
                          className="progress"
                          style={{ width: `${progressPercentage}%` }}
                        ></div>
                      </div>
                      <div className="gm secondaryColor fs-14 mb-30">
                        {itemQuizSet?.setAttemptedQuestionsCount}/
                        {itemQuizSet?.setQuestionsCount} questions{" "}
                      </div>
                      <div className="fs-20 tgb mb-10">
                        {itemQuizSet?.setName}
                      </div>
                      <div className="l15 mb-32">
                        {!isExpanded
                          ? itemQuizSet?.setDescription
                          : itemQuizSet?.setDescription?.slice(0, 100)}
                        {itemQuizSet?.setDescription?.length > 200 && (
                          <div
                            onClick={() =>
                              toggleShowMore(`${indexQuizData}-${indexQuizSet}`)
                            }
                            className="show-more-less-clickable"
                          >
                            {!isExpanded ? t("View less") : t("View more")}
                          </div>
                        )}
                      </div>
                      {itemQuizSet?.setStatus !== "complete"&& (
                      <button
                        className={
                          // itemQuizSet?.setStatus === "complete"
                          //   ? "startBtn not-allowed"
                            "startBtn cursor-pointer"
                        }
                        onClick={() => {
                          navigate("/quiz-form", {
                            state: { itemQuizSet: itemQuizSet, state: state,indexQuizSet:indexQuizSet,getPendingMonthsSelector:state?.getPendingMonthsSelector },
                          });
                          setItem("setDetails",itemQuizSet)
                        }}
                        disabled={itemQuizSet?.setStatus === "complete"}
                      >
                        {t("Start")}
                      </button>
                      )}
                    </div>
                  </>
                );
              });
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default QuizList;
